import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSortRows = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 7,
	height: 21,
	viewBox: "0 0 7 21",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		stroke: "#4A5666",
		children: [/* @__PURE__ */ _jsx("path", {
			strokeLinecap: "square",
			strokeWidth: 1.5,
			d: "M3.607 7.071v10"
		}), /* @__PURE__ */ _jsx("path", {
			fill: "#4A5666",
			strokeWidth: 2,
			d: "m3.607 18.642-1.5-3h3zM3.607 2.571l1.5 3h-3z"
		})]
	})
});
export default SvgSortRows;
